var _rect, _rect2, _path, _rect3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureStandardize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 13,
    width: 66,
    height: 90,
    rx: 8,
    fill: "#E8EDF3",
    transform: "rotate(-7 68 58)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 26,
    width: 66,
    height: 88,
    rx: 8,
    fill: "#D7E0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 44h39M70 56h32M70 68h24",
    stroke: "#A6B2C2",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 79,
    width: 41,
    height: 24,
    rx: 12,
    fill: "#DEEEE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m81 90 6 6 12-13",
    stroke: "#357653",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureStandardize);
export default __webpack_public_path__ + "static/media/feature-standardize.eb1960b58aa45f79d6fd7e1ee3486f3b.svg";
export { ForwardRef as ReactComponent };